<div class="relative">
  <p-tabs [value]="tabMenuItems[tabMenuActiveIdx].label"  [scrollable]="true">
    <p-tablist>
      @for (tab of tabMenuItems; track tab.label;let idx=$index) {
        <p-tab [value]="tab.label" (click)="onTabChange(idx,tab)">{{ tab.label }}</p-tab>
    }
    </p-tablist>
  </p-tabs>


  <div class="tab-table-header-button">

    @if (storeList && storeList.length > 0 && isOnMegaMenu) {
      <p-select appendTo="body"  (onChange)="isStoreSelected($event)"
                  [(ngModel)]="selectedStore" [options]="storeList | orderBy: 'name'" optionLabel="name" [filter]="true"/>
    }
  </div>

  <!-- <button pButton type="button" label=" Store" icon="pi pi-plus" tooltip="Add new store"
  class="button-container-store-tab position-absolute  end-0 "
  tooltipPosition="top" (click)="addStore()">
</button>  -->
</div>

<router-outlet></router-outlet>
